import Notification from './NotificationContainer';

export default Notification;